import { createApp } from 'vue';
import DocxToEpubConverter from '@/Components/DocxToEpubConverter.vue';
import '@styles/app.css';

createApp(DocxToEpubConverter).mount('#docx-to-epub-converter');
